import { useContext } from 'react';
import { TranslationContext } from '../contexts/translationContext';

export const useTranslationContext = () => useContext(TranslationContext);
